import { render, staticRenderFns } from "./SavedSearch.vue?vue&type=template&id=896295ec&scoped=true&"
import script from "./SavedSearch.vue?vue&type=script&lang=js&"
export * from "./SavedSearch.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearch.vue?vue&type=style&index=0&id=896295ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896295ec",
  null
  
)

export default component.exports